import { convertLength } from '@mui/material/styles/cssUtils';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { LineChart } from '@mui/x-charts';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/styles/cssUtils": { convertLength }, "@mui/material/styles": { createTheme, responsiveFontSizes }, "@mui/material/Box": Box, "@mui/x-charts": { LineChart } } } });
export default ClientProvider;
